module.exports = __webpack_public_path__ + "src/assets/img/fakecode.6348c48b.png";